import React from "react";
import "./Contact.css";
import phoneIcon from "../../assets/icons/callIcon.svg";
import whatsappIcon from "../../assets/icons/footer icons/4.svg";

function FloatingContact() {
  return (
    <div className="floating_contact">

      {/* WhatsApp → 03237478521 */}
      <a
        href="https://wa.me/971521743345?text=Hi%2C%20I%E2%80%99d%20like%20to%20request%20a%20quote%20for%20home%20maintenance%20services."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp_btn"
      >
        <img src={whatsappIcon} alt="whatsapp" className="whtsapp_icon"  alt="whatspp_icon"/>
      </a>

      {/* Call → +971 52 174 3345 */}
    <a
  href="tel:+971521743345"
  className="call_btn"
>
  <img src={phoneIcon} alt="call" />
</a>

    </div>
  );
}

export default FloatingContact;